import React from "react";
import { useSelector } from "react-redux";
import { selectListSummary } from "../../redux/reducers/slice/event";
import { List } from "react-virtualized";

interface IProps {
  isTVDevice: boolean;
}

const ListSummary = ({ isTVDevice }: IProps) => {
  const lstSummary = useSelector(selectListSummary);

  const showSTT = (stt: number) => {
    if (stt < 10) {
      return `0${stt}`;
    }
    return stt;
  };

  const showCustomerName = (name: string) => {
    if (!name?.trim()?.length) {
      return ""
    }

    const nameSplit = name.split(" ");
    if (nameSplit?.length > 3) {
      return "*** " + nameSplit[nameSplit.length - 1]
    }

    return nameSplit
      .map((item, index) => {
        if (index === nameSplit.length - 1) {
          return item;
        }
        return item.replace(/[^\s]/g, "*");
      })
      .join(" ");
  };

  const renderRows = ({ index, isScrolling, key, style }: IRowRender) => {
    const item = lstSummary[index];
    const img =
      index % 2 === 0
        ? "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/row-2.svg"
        : "https://kdstore.s3.ap-southeast-1.amazonaws.com/static/lucky_wheel/row-1.svg";

    if (item.is_empty) {
      return (
        <div
          className="customer-reward-info"
          key={key}
          style={{ ...style, backgroundImage: `url("${img}")` }}>
          <div>
            <div>
            </div>
          </div>
          <div>
          </div>
          <div>
          </div>
          <div>
          </div>
        </div>
      );
    }

    return (
      <div
        className="customer-reward-info"
        key={key}
        style={{ ...style, backgroundImage: `url("${img}")` }}>
        <div>
          <div>
            {showSTT(lstSummary?.filter((x) => !x.is_empty).length - index)}
          </div>
        </div>
        <div>
          <div>{showCustomerName(item.customer_name)}</div>
        </div>
        <div>
          <div>{item.kde_order_id}</div>
        </div>
        <div>
          <div>{item.gift_display_name}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="customer-rewards">
      <div className="customer-rewards-header">
        <div>
          <div>STT</div>
        </div>
        <div>
          <div>Khách hàng</div>
        </div>
        <div>
          <div>Mã đơn hàng</div>
        </div>
        <div>
          <div>Trúng thưởng</div>
        </div>
      </div>
      <List
        className={"lst-summary-wrapper"}
        height={isTVDevice ? 480 : 470}
        overscanRowCount={10}
        rowCount={lstSummary?.length ? lstSummary.length : 0}
        rowHeight={isTVDevice ? 48 : 47}
        rowRenderer={renderRows}
        // scrollToIndex={scrollToIndex}
        width={isTVDevice ? 860 : 841}
      />
    </div>
  );
};
export default ListSummary;

interface IRowRender {
  index: number;
  isScrolling: boolean;
  key: string;
  style?: any;
}
